import React from 'react';
import CaseLabelPrinter from '../../pages/print/CaseLabelPrinter';

const BottlingItemsTable = ({ 
  items,
  wines, 
  onAddItem, 
  onEditItem, 
  onRemoveItem, 
  areDatesSet,
  getDateWarningMessage,
  materialsByType 
}) => {
  return (
    <div className="card mb-4">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5 className="mb-0">Items to be Bottled</h5>
          <button
            type="button"
            className="btn btn-outline-success"
            disabled={!areDatesSet()}
            onClick={onAddItem}
          >
            Add Item
          </button>
        </div>
        {!areDatesSet() && (
          <div className={`alert ${getDateWarningMessage().includes("future") ? "alert-warning" : "alert-info"} py-2 mb-0`}>
            <small>{getDateWarningMessage()}</small>
          </div>
        )}
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>Wine</th>
                <th>Gallons</th>
                <th>Bottle Type</th>
                <th>Est. Cases</th>
                <th>Cork</th>
                <th>Capsule</th>
                <th>Label</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">No items added</td>
                </tr>
              ) : (
                items.map((item) => {
                  // Find materials by their IDs
                  const bottleMaterial = materialsByType.bottles.find(b => b.materialID === parseInt(item.bottleID));
                  const corkMaterial = materialsByType.corks.find(c => c.materialID === parseInt(item.corkID));
                  const capsuleMaterial = materialsByType.capsules.find(c => c.materialID === parseInt(item.capsuleID));
                  const labelMaterial = materialsByType.labels.find(l => l.materialID === parseInt(item.labelID));
                  
                  return (
                    <tr 
                      key={item.itemID}
                      onClick={() => onEditItem(item)}
                      className="table-row-hover"
                      style={{ cursor: 'pointer' }}
                    >
                      <td>{item.varietal || `Wine ID: ${item.wineID}`}</td>
                      <td>{item.gallonsPlanned}</td>
                      <td>
                      {bottleMaterial ? (
                        parseFloat(bottleMaterial.bottleVolume) >= 3000 ? 
                          `${item.casesEstimated} units` : 
                          `${item.casesEstimated} cases`
                      ) : 'Unknown'}
                      </td>
                      <td>{item.casesEstimated}</td>
                      <td>{corkMaterial ? corkMaterial.name : 'None'}</td>
                      <td>{capsuleMaterial ? capsuleMaterial.name : 'None'}</td>
                      <td>{labelMaterial ? labelMaterial.name : 'None'}</td>
                      <td>
                      <div className="btn-group">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent row click triggering
                              onRemoveItem(item.itemID);
                            }}
                          >
                            Remove
                          </button>
                          <CaseLabelPrinter 
                            item={item} 
                            wine={item.varietal ? item : null} 
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BottlingItemsTable;